// Cây phẳng từ backend (thứ tự (code, id)) → index tra con O(1) bằng Map, dựng một lượt O(n).
// Quy tắc: node là root khi parentId null HOẶC parentId không có trong tập input (dangling —
// coi như root để không mất node khỏi cây). Thứ tự roots và children giữ nguyên thứ tự input.

export type TreeNodeLike = Readonly<{ id: string; parentId?: string | null | undefined }>;

export type TreeIndex<T extends TreeNodeLike> = Readonly<{
  roots: T[];
  childrenByParent: Map<string, T[]>;
}>;

export function buildTreeIndex<T extends TreeNodeLike>(nodes: readonly T[]): TreeIndex<T> {
  const knownIds = new Set(nodes.map((entry) => entry.id));
  const childrenByParent = new Map<string, T[]>();
  const roots: T[] = [];
  for (const entry of nodes) {
    if (entry.parentId != null && knownIds.has(entry.parentId)) {
      const siblings = childrenByParent.get(entry.parentId);
      if (siblings) {
        siblings.push(entry);
      } else {
        childrenByParent.set(entry.parentId, [entry]);
      }
    } else {
      roots.push(entry);
    }
  }
  return { roots, childrenByParent };
}
